import { gql } from '@apollo/client';

export const GET_BUY_HEALTH_POLICY_VAR_DETAILS = gql`
  query getBuyHealthPolicyDetails {
    buyHealthPolicy @client
  }
`;

export const GET_MEDICAL_QUESTIONS = gql`
query getMedicalQuestions($input: productCodeInput) {
  productQuestionList(input: $input) {
      srNo
      label
      isChkReq
      isChkTxtReq
      isParent
      condToChild
      childQuesNo
    }
  }
`;

export const SAVE_QUOTE = gql`
  mutation saveQuote($input: QuoteInput) {
    saveQuote(input: $input) {
      quoteNumber
      quoteCreationDate
      status
    }
  }
`;

export const SEND_POLICY_SMS = gql`
  mutation sendPolicySms(
    $input: ProposalInput
    $proposalNumber: String
    $mobile: String
    $policyNumber: String
  ) {
    sendPolicySMS(
      input: $input
      proposalNumber: $proposalNumber
      mobile: $mobile
      policyNumber: $policyNumber
    ) {
      message
    }
  }
`;

export const SEND_POLICY_EMAIL = gql`
  mutation sendPolicyEmail(
    $input: ProposalInput
    $proposalNumber: String
    $email: String
    $policyNumber: String
  ) {
    sendPolicyEmail(
      input: $input
      proposalNumber: $proposalNumber
      email: $email
      policyNumber: $policyNumber
    ) {
      message
    }
  }
`;

export const SEND_POLICY_PDF = gql`
  mutation sendPolicyPDF(
    $input: ProposalInput
    $proposalNumber: String
    $policyNumber: String
  ) {
    sendPolicyPDF(
      input: $input
      proposalNumber: $proposalNumber
      policyNumber: $policyNumber
    ) {
      base64Pdf
    }
  }
`;

export const SEARCH_CUSTOMER_BY_NUMBER = gql`
query searchCustomerByNumber($input: ViewCustInput) {
  customer(input: $input) {
      cust_number
      cust_type {
        code
        value
      }
      is_blackListed
      cust_ref_number
      ciu_type
      bank_detail {
        name
        branch_name
        ifsc_code
        acc_number
      }
      indv_detail {
        employeeNumber
        gst_number
        title {
          code
          value
        }
        first_name
        middle_name
        surname
        full_name
        gender {
          code
          value
        }
        date_of_birth
        id_proof_type {
          code
          value
        }
        id_proof_number
        pan_card_number
        marital_status {
          code
          value
        }
        occupation {
          code
          value
        }
        nationality {
          code
          value
        }
        mother_maiden_name
        ckyc_id_number
        eia_required
        eia_number
        ir_repository
        ckycid_available
        kyc_compliant
      }
      org_detail {
        org_name
        org_type {
          code
          value
        }
        contact_name
        contact_email
        tan_number
        reg_number
        gst_number
        ckyc_id_number
        udyog_aadhaar_number
        certificate_of_incorporation
      }
      contact {
        email
        mobile
        telephone
        fax_number
        alt_telephone
        alt_mobile
      }
      permanent_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      comm_equal_perm
      communication_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      alert_action {
        alertCount
        alertContext {
          alert
          action
        }
      }
    }
  }
`;

export const SEARCH_CUSTOMERS = gql`
query searchCustomers($filter: CustomerFilter) {
  _customer_meta(filter: $filter) {

      resultCount
      maxRow
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
    customers(filter: $filter) {
    
      cust_type {
        code
        value
      }
      cust_number
      indv_detail {
        full_name
      }
      org_detail {
        org_name
      }
      contact {
        email
        mobile
      }
      permanent_address {
        location
      }
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const PINCODE_LOOKUP = gql`
query customerAddress($filter: PincodeFilter) {
  pincodeInfo(filter: $filter) {
      cityCode
      city
      districtCode
      district
      pinCode
      pinCodeLocality
      stateCode
      state
      countryCode
      country
    }
  }
`;

export const CALCULATE_PREMIUM_FOR_PROPOSAL = gql`
  query calculatePremiumForProposal($input: ProposalInput) {
    calculatePremiumForProposalST(input: $input) {
      basePremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      breakup {
        relationship
        gender
        age
        premium
        ppcTestLevel
      }
      warningMsg
    }
  }
`;

export const SAVE_PROPOSAL = gql`
  mutation saveProposalST($input: ProposalInput) {
    saveProposalST(input: $input) {
      customerID
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      premium {
        basePremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        breakup {
          relationship
          gender
          age
          premium
        }
      }
      warningMsg
    }
  }
`;

export const SEND_PROPOSAL_PDF = gql`
  mutation sendProposalPDF(
    $input: ProposalInput
    $proposalNumber: String
  ) {
    sendProposalPDF(input: $input, proposalNumber: $proposalNumber) {
      base64Pdf
    }
  }
`;

export const BUY_POLICY = gql`
  mutation buyPolicy($input: PolicyInput) {
    issuePolicy(input: $input) {
      policyNo
      receiptID
      referenceNumber
      digiLink
      displayMessage
      additionalMessage
    }
  }
`;

export const QUERY_STATE = gql`
  query {
    quoteIntermediary @client
  }
`;

export const CUSTOMER_BANK_DETAILS = gql`
query customerBankDetails($filter: BankFilter) {
  _bankInfo_meta(filter: $filter) {
      maxRow
      resultCount
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
    bankInfo(filter: $filter) {
      branch_name
      ifsc_code
      name
      branch_address
      bank_code
      micr_code
    }
  }
`;

export const RENEWAL_MANDATE_DETAILS = gql`
  query renewalMandateData($productCode: StrictNumber) {
    PRD_TermForMandate(productCode: $productCode) {
      code
      value
    }
    PRD_RenewalPaymentMandateTakenInTheNameOf(
      productCode: $productCode
    ) {
      code
      value
    }
    typeOfDebit {
      code
      value
    }
    destinationBankAccountType {
      code
      value
    }
  }
`;

export const DEFAULT_BANK_NAME = gql`
  query defaultBankName {
    defaultBankName {
      code
      value
    }
  }
`;

export const FINAL_COLLECTION_DATE = gql`
query finalCollectionDate($input: FinalCollectDateInput) {
  finalCollectionDate(input: $input) {
      date
    }
  }
`;

export const PROPOSER_DROPDOWN_DETAIL = gql`
  query getProposerDropdownList($productCode: StrictNumber) {
    PRD_OccupationList(productCode: $productCode) {
      code
      value
    }
    PRD_PreExistDiseaseWaitPeriod(productCode: $productCode) {
      code
      value
    }
    PRD_NomiRelationWithMemb(productCode: $productCode) {
      code
      value
    }
    PRD_ApointRelationWithMinNomi(productCode: $productCode) {
      code
      value
    }
    PRD_CumulativeBonus(productCode: $productCode) {
      code
      value
    }
  }
`;

export const CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL = gql`
  query customerIndividualDetail {
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
    maritalStatusList {
      code
      value
    }
    occupationList {
      code
      value
    }
    nomineeRelationshipList {
      code
      value
    }
    idProofTypeList {
      code
      value
    }
    nationalityList {
      code
      value
    }
    eiaRequired {
      code
      value
    }
    ciuTypeList{
      code
      value
    }
  }
`;

export const GET_BUSINESS_TYPE = gql`
  query businessType {
    businessTypeList {
      code
      value
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const GET_GENDER_LIST = gql`
  query genderList {
    genderList {
      code
      value
    }
  }
`;

export const CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL = gql`
  query customerOrganisationDetails {
    organisationList {
      code
      value
    }
  }
`;

export const PAY_PREMIUM_LIST = gql`
  query payPremiumList {
    PayMethodPayerTypeList {
      code
      value
    }
    ChequeTypeList {
      code
      value
    }
    PaymentTypeList {
      code
      value
    }
    ProposalPaymentTypeList {
      code
      value
    }
  }
`;

export const VERIFY_ONLINE_TRANSACTION = gql`
query verifyOnlineTransaction($input: verifyOnlineTranscInput) {
  verifyOnlineTransaction(input: $input) {
      isPaymentDone
    }
  }
`;

export const INTERMEDIARY_CD_ACCOUNTS = gql`
  query intermediaryCDAccounts(
    $intermediaryCode: String
    $customerID: String
  ) {
    intermediaryCDAccounts(
      intermediaryCode: $intermediaryCode
      customerID: $customerID
    ) {
      AccountID
      AccountBalance
    }
  }
`;

export const ROLLOVER_COMPANY_LIST = gql`
  query rollOverCompanyList {
    rolloverCompanyList {
      code
      value
    }
  }
`;

export const DEFAULT_ID_PROOF = gql`
  query defaultIDProof {
    defaultIdProof {
      code
      value
    }
  }
`;

export const CHARACTER_LIMIT_LIST = gql`
  query characterLimitList {
    characterLimitList {
      code
      value
    }
  }
`;
export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        linkTo
      }
    }
  }
`;
export const VERIFY_CRN_NUMBER = gql`
  query verifyCRNNumber(
    $crnNumber: String
  ) {
    verifyCRNNumber(
      crnNumber: $crnNumber
    ) {
      isVerified
    }
  }
`;
export const CHECK_DUPLICATE_CUSTOMER =gql`
query checkDuplicateCust ($inputCust: CustDuplicateInput ){
  checkDuplicateCust (inputCust: $inputCust){
    isDuplicateCustomer
    ErrorMsg
  }
}
`;
export const CHECK_IMD_CONFIG = gql`
  query checkConfigImd($intermediaryCode: String){
    checkConfigImd( intermediaryCode: $intermediaryCode){
      isConfiguredIMD
    }
  }
`;
export const PROFILE_DETAILS = gql`
  query userMyDetail {
    userMyDetail {
      userId
      userType {
        typeName
      }
      profile {
        userImage
        firstName
        middleName
        lastName
        mobileNumber
        emailId
      }
      userCategory {
        categoryName
      }
      organisation {
        intermediaries {
          intermediaryName
          intermediaryCode
          isSelected
        }
      }
      status
    }
  }
`;